module.exports = __webpack_public_path__ + "static/media/110a.8b64d139.svg";